import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import GuideStepContent from "components/guide-step-content";
import { Icon } from "designsystem";
import { FaqItem } from "utils/support/faq";

interface FaqItemProps {
  item: FaqItem;
  selectedKeyword?: string;
  currentPage?: number;
  // baseUrl: string;
  // productSlug: string;
  // locale: string;
}

const FaqItemTest: React.FC<FaqItemProps> = ({
  item,
  selectedKeyword,
  currentPage
}) => {
  const [isOpenFaqItem, setIsOpenFaqItem] = useState<boolean>(false);

  useEffect(() => {
    // Check if the URL hash matches this FAQ item's slug
    if (window.location.hash === `#${item?.slug}`) {
      setIsOpenFaqItem(true);
    }
  }, [item?.slug]);

  // function to toggle accordion
  const toggleAccordionFaqItem = (): void => {
    setIsOpenFaqItem(!isOpenFaqItem);
  };

  const handleCopyFAQItem = (): void => {
    const origin = window.location.origin;
    const pathname = window.location.pathname;
    const topicQuery =
      item?.topics && selectedKeyword
        ? `?topic=${encodeURIComponent(selectedKeyword)}`
        : "";
    const faqItemQuery = item?.slug ? `&faq-item=#${item?.slug}` : "";
    const faqItemCurrentPage = `&page=${currentPage}`;
    const urlWithTopicCurrentPageFAQSlug = `${origin}${pathname}${topicQuery}${faqItemCurrentPage}${faqItemQuery}`;

    // Modify the URL without reloading the page
    window.history.pushState({}, "", urlWithTopicCurrentPageFAQSlug);

    // Copy the url to the clipord
    navigator.clipboard.writeText(urlWithTopicCurrentPageFAQSlug);
  };

  return (
    <li
      key={`#${item?.slug}`}
      id={`${item.slug}`}
      className=" border-b p-6 before:list-none mt-0 "
    >
      <div
        className="flex justify-between gap-4 items-center cursor-pointer"
        onClick={toggleAccordionFaqItem}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            toggleAccordionFaqItem();
          }
        }}
        role="button"
        tabIndex={0}
      >
        <h3 className="text-medium font-bold leading-6">{item?.question}</h3>
        <div>
          <Icon
            className={`${
              isOpenFaqItem
                ? "w-4 transition-all duration-300 ease-in-out rotate-180"
                : "w-4 transition-all duration-300 ease-in-out"
            }`}
            type={"chevron_down"}
          />
        </div>
      </div>
      {isOpenFaqItem && (
        <AnimatePresence>
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
            className=" flex items-start gap-3 mt-6"
          >
            <div className="[&_p]:text-medium [&_p]:leading-6 [&_p]:tracking-default [&_p]:text-nexi-colorPalette-neutral-20 [&_h1]:font-bold [&_h1]:text-medium-header [&_h1]:leading-7 [&_h1]:tracking-normal [&_h3]:font-bold [&_h3]:text-medium [&_h3]:leading-6 [&_h3]:tracking-normal">
              <GuideStepContent contents={item?.answer} />
            </div>
            <Icon
              className={" mt-3 cursor-copy"}
              type={"link"}
              onClick={handleCopyFAQItem}
            />
          </motion.div>
        </AnimatePresence>
      )}
    </li>
  );
};

export default FaqItemTest;
